import { render } from "./CheckBalanceLinkGenerator.vue?vue&type=template&id=2754c677"
import script from "./CheckBalanceLinkGenerator.vue?vue&type=script&lang=js"
export * from "./CheckBalanceLinkGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__